import script from "./VaccinationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VaccinationPage.vue?vue&type=script&setup=true&lang=js"

import "./VaccinationPage.vue?vue&type=style&index=0&id=eef5195a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eef5195a"]])

export default __exports__